module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/profile.component.css
// module id = ./src/app/profile/profile.component.css
// module chunks = main